import React, { useState } from "react";

// Sample data for the invoices
const initialData = [
 
  
];

const itemsPerPage = 5; // Number of items per page

const RechargeAndBillInvoice = () => {
  const [data, setData] = useState(initialData);
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);

  // Filter data based on the search query
  const filteredData = data.filter((item) => {
    return (
      item.MobileNo.includes(searchQuery) ||
      item.Name.toLowerCase().includes(searchQuery.toLowerCase()) ||
      item.Email.toLowerCase().includes(searchQuery.toLowerCase())
    );
  });

  // Paginate filtered data
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);

  // Handle search input change
  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
    setCurrentPage(1); // Reset to page 1 when search query changes
  };

  // Show all data
  const showAllData = () => {
    setData(initialData);
    setCurrentPage(1); // Reset to page 1
  };

  // Handle next page
  const handleNext = () => {
    if (currentPage < Math.ceil(filteredData.length / itemsPerPage)) {
      setCurrentPage(currentPage + 1);
    }
  };

  // Handle previous page
  const handlePrev = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  // Generate page numbers for pagination
  const totalPages = Math.ceil(filteredData.length / itemsPerPage);
  const pageNumbers = [];
  for (let i = 1; i <= totalPages; i++) {
    pageNumbers.push(i);
  }

  return (
    <div>
      <h1 style={{ fontSize: "18px" }}></h1>

      {/* Search Input and Show Button */}
      <div>
        <input
          type="text"
          placeholder="Search by Mobile No., Name, or Email"
          value={searchQuery}
          onChange={handleSearchChange}
          style={{ padding: "5px", width: "250px", fontSize: "12px" }} // Smaller search box and text
        />
        <button
          onClick={showAllData}
          style={{ padding: "5px 10px", marginLeft: "10px", fontSize: "12px" }}
        >
          Show
        </button>
      </div>

      {/* Invoice Table with Scroll */}
      <div style={{ overflowX: "auto", marginTop: "20px" }}>
        {" "}
        {/* Enables horizontal scrolling */}
        <table
          border="1"
          cellPadding="5"
          cellSpacing="0"
          style={{ width: "100%", minWidth: "900px", fontSize: "12px" }}
        >
          {" "}
          {/* Set font size for table */}
          <thead>
            <tr>
              <th>Sr.No.</th>
              <th>Mobile No.</th>
              <th>Name</th>
              <th>Email</th>
              <th>Amount</th>
              <th>Order Id</th>
              <th>Txn No.</th>
              <th>Txn Date</th>
              <th>Service</th>
              <th>Status</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {currentItems.map((item) => (
              <tr key={item.SrNo}>
                <td>{item.SrNo}</td>
                <td>{item.MobileNo}</td>
                <td>{item.Name}</td>
                <td>{item.Email}</td>
                <td>{item.Amount}</td>
                <td>{item.OrderId}</td>
                <td>{item.TxnNo}</td>
                <td>{item.TxnDate}</td>
                <td>{item.Service}</td>
                <td>{item.Status}</td>
                <td>
                  <button style={{ fontSize: "12px" }}>Get Invoice</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Pagination Controls */}
      <div style={{ marginTop: "20px", textAlign: "center" }}>
        <button
          onClick={handlePrev}
          disabled={currentPage === 1}
          style={{ padding: "5px 10px", fontSize: "12px" }}
        >
          Previous
        </button>

        {/* Page Numbers */}
        {pageNumbers.map((number) => (
          <button
            key={number}
            onClick={() => setCurrentPage(number)}
            style={{
              padding: "5px 10px",
              fontSize: "12px",
              marginLeft: "5px",
              backgroundColor:
                currentPage === number ? "#007BFF" : "transparent",
              color: currentPage === number ? "white" : "black",
            }}
          >
            {number}
          </button>
        ))}

        <button
          onClick={handleNext}
          disabled={currentPage === totalPages}
          style={{ padding: "5px 10px", fontSize: "12px", marginLeft: "5px" }}
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default RechargeAndBillInvoice;
